import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Denmark",
  "use": "icon-Denmark-usage",
  "viewBox": "0 0 1365 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1365 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Denmark\"><path d=\"M0 0h1365.333333v1024H0z\" fill=\"#C51918\" p-id=\"17314\" /><path d=\"M409.6 0h204.8v409.6h750.933333v204.8H614.4v409.6H409.6V614.4H0V409.6h409.6z\" fill=\"#F7FCFF\" p-id=\"17315\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol